import { useTranslation } from "@opendash/i18n";
import { Dropdown, Flex, Tag, Tooltip, Typography } from "antd";
import { ItemType } from "antd/es/menu/interface";
import { observer } from "mobx-react-lite";
import React, { useMemo } from "react";
import { getDowntimeProps, PriorityIcon } from "../../../../priority";
import { useSaveConfigManager } from "../../../hooks/useSaveConfigManager";

type Props = {
  value?: Number | string;
  onChange?: (value: Number | string) => void;
};

export const DowntimeInputSelect = observer((props: Props) => {
  const t = useTranslation();
  const manager = useSaveConfigManager();
  const config = manager.getFieldConfig("priority");
  const { thresholds, getDowntimeLabelByValue } = getDowntimeProps();
  const actualThresholds = config?.downtime ?? thresholds;

  const menuItems: ItemType[] = useMemo(
    () => actualThresholds.map(mapThresholdsToItems),
    []
  );

  function mapThresholdsToItems(threshold: number): ItemType {
    return {
      key: threshold,
      label: (
        <Flex gap="small" align="center">
          <PriorityIcon value={threshold} />
          <Typography.Text>
            {getCustomLabelByThreshold(threshold)}
          </Typography.Text>
        </Flex>
      ),
    };
  }
  function getCustomLabelByThreshold(threshold: number): string {
    const label = getDowntimeLabelByValue(threshold);
    return (
      config?.customLabels?.find((l) => l.label === label)?.value ?? t(label)
    );
  }

  const downtimeValue = props.value ? Number(props.value) : actualThresholds[0];

  return (
    <Dropdown
      trigger={["click"]}
      menu={{
        items: menuItems,
        selectable: true,
        selectedKeys: [props.value?.toString()],
        onSelect: (info) => props.onChange(Number.parseInt(info.key)),
      }}
    >
      <Tooltip
        title={t("maintenance:ticket.creation.priority.downtime.tooltip")}
      >
        <Tag style={{ cursor: "pointer" }}>
          <Flex align="center" gap="small">
            <PriorityIcon value={downtimeValue} />
            <Typography.Text>
              {getCustomLabelByThreshold(downtimeValue)}
            </Typography.Text>
          </Flex>
        </Tag>
      </Tooltip>
    </Dropdown>
  );
});
